export const GET_USER_DEFINITIONS_PASSWORD_SEND_MAIL = "GET_USER_DEFINITIONS_PASSWORD_SEND_MAIL"
export const GET_USER_DEFINITIONS_PASSWORD_SEND_MAIL_SUCCESS = "GET_USER_DEFINITIONS_PASSWORD_SEND_MAIL_SUCCESS"
export const GET_USER_DEFINITIONS_PASSWORD_SEND_MAIL_FAIL = "GET_USER_DEFINITIONS_PASSWORD_SEND_MAIL_FAIL"

export const GET_USER_DEFINITIONS_BY_GUID = "GET_USER_DEFINITIONS_BY_GUID"
export const GET_USER_DEFINITIONS_BY_GUID_SUCCESS = "GET_USER_DEFINITIONS_BY_GUID_SUCCESS"
export const GET_USER_DEFINITIONS_BY_GUID_FAIL = "GET_USER_DEFINITIONS_BY_GUID_FAIL"

export const UPDATE_USER_DEFINITIONS_NEW_PASSWORD = "UPDATE_USER_DEFINITIONS_NEW_PASSWORD"
export const UPDATE_USER_DEFINITIONS_NEW_PASSWORD_SUCCESS = "UPDATE_USER_DEFINITIONS_NEW_PASSWORD_SUCCESS"
export const UPDATE_USER_DEFINITIONS_NEW_PASSWORD_FAIL = "UPDATE_USER_DEFINITIONS_NEW_PASSWORD_FAIL"

export const USER_DEFINITIONS_NEW_PASSWORD_API_ERROR = "USER_DEFINITIONS_NEW_PASSWORD_API_ERROR"
